import { createAsyncThunkActionTypes } from './action-utils';

export const readServicePointDeliveryStatus = createAsyncThunkActionTypes(
  'deliveryStatus/readServicePointDeliveryStatus',
);

export const createServicePointCustomerDiggingStatus = createAsyncThunkActionTypes(
  'dealiveryStatus/createServicePointCustomerDiggingStatus',
);
